import { TextStepView } from "../TextStepView";
import type { Q3DeliveryProps } from "./types";

export function TextQ3({ rebuttal, onArgument, onReply, ...step }: Q3DeliveryProps) {
  return (
    <TextStepView
      {...step}
      onSubmit={(text, auto) =>
        rebuttal
          ? onReply(rebuttal.kind, text, { auto_submitted: auto })
          : onArgument(text, { auto_submitted: auto })
      }
    />
  );
}
